function parallaxScroll (){
    if (window.innerWidth > 1200) {
        const paralaxElements = document.querySelectorAll('.parallax');

        // Get the natural background size of each element
        paralaxElements.forEach(element => {
            let bgImage = new Image();
            bgImage.src = window.getComputedStyle(element).backgroundImage.slice(5, -2);
            bgImage.onload = function() {
                let aspectRatio = this.naturalWidth / this.naturalHeight;
                let minBgSize = Math.max(element.offsetWidth, element.offsetHeight * aspectRatio);
                let elementSize = Math.max(element.offsetWidth, element.offsetHeight);
                let minBgSizePercent = (minBgSize / elementSize) * 100;

                element.setAttribute('data-min-bg', minBgSizePercent);
            }
        });

        const updateParalaxes = () => {
            paralaxElements.forEach(element => {
                let bounding = element.getBoundingClientRect();
                
                if (bounding.top < window.innerHeight && bounding.bottom > 0) {
                    let relativePosition = (window.innerHeight - bounding.top) / window.innerHeight;
                    let bgImage = new Image();
                    bgImage.src = window.getComputedStyle(element).backgroundImage.slice(5, -2);
                    console.log('bg img', bgImage.src);
                    
                    let minBgSize = element.getAttribute('data-min-bg') ?? 120;

                    console.log('minBgSize', minBgSize);

                    element.style.backgroundSize = `${Math.max((relativePosition * 120), minBgSize)}%`;

                }
            });
        }

        window.addEventListener("scroll", updateParalaxes);
        updateParalaxes();
    }
}

export default parallaxScroll;
